import React, { useEffect, useState } from 'react';
import {Redirect, Route} from 'react-router-dom';
import {useSelector} from 'react-redux';
import { userManager } from '@app/utils/oidc';
import { isTokenValid } from '@app/utils/helper';
// // import {TOKEN_KEY} from '../utils/define';

// const PublicRoute = ({children, ...rest}) => {
//     const isLoggedIn = useSelector((state) => state.auth.isLoggedIn);
//     // const isAuthenticated = isLoggedIn || localStorage.getItem(TOKEN_KEY);

//     return (
//         <Route
//             {...rest}
//             render={({location}) =>
//             isLoggedIn ? (
//                     <Redirect
//                         to={{
//                             pathname: '/',
//                             state: {from: location}
//                         }}
//                     />
//                 ) : (
//                     children
//                 )
//             }
//         />
//     );
// };

// export default PublicRoute;


const PublicRoute = ({ children, ...rest }) => {
  // const isLoggedIn = useSelector(s => s.auth.isLoggedIn);
  // const isLoggedIn = await userManager.getUser().then(user => !!user).catch(() => false);
  const [isLoggedIn, setIsLoggedIn] = useState(null);

  useEffect(() => {
    isTokenValid().then(setIsLoggedIn);
  }, []);

  if (isLoggedIn === null) return null;

  return (
    <Route 
      {...rest}
      render={({ location }) =>
        isLoggedIn && location.pathname !== '/' ? (
          <Redirect to={{ pathname: '/', state:{ from: location }}}/>
        ) : (
          children
        )
      }
    />
  );
};

export default PublicRoute;